module.exports = __webpack_public_path__ + "static/media/download.0cefcdc9.svg";